module.exports = __webpack_public_path__ + "img/member-huobi.c5da5779.png";